export enum AccountType {
  SAVINGS = 'SAVINGS',
  CHECKING = 'CHECKING',
}

export const AVAILABLE_ACCOUNT_TYPE = Object.keys(AccountType);

class BankAccount {
  public readonly id: string;
  public readonly bankCode: string;
  public readonly branchCode: string;
  public readonly accountType: AccountType;
  public readonly accountNumber: string;
  public readonly accountName: string;
  constructor({
    id,
    bankCode,
    branchCode,
    accountType,
    accountNumber,
    accountName,
  }: {
    id: string;
    bankCode: string;
    branchCode: string;
    accountType: AccountType;
    accountNumber: string;
    accountName: string;
  }) {
    this.id = id;
    this.bankCode = bankCode;
    this.branchCode = branchCode;
    this.accountType = accountType;
    this.accountNumber = accountNumber;
    this.accountName = accountName;
  }

  public static fromJSON = (value: any) => {
    const { id, bank_code, branch_code, account_type, account_number, account_name } = Object.assign({}, value);
    const accountType_ = String(account_type).toUpperCase();

    if (typeof id !== 'number') throw new TypeError('.id must be a number');
    if (typeof bank_code !== 'string') throw new TypeError('.bank_code must be a string');
    if (typeof branch_code !== 'string') throw new TypeError('.branch_code must be a string');
    if (accountType_ && !AVAILABLE_ACCOUNT_TYPE.includes(accountType_))
      throw new TypeError('.account_type must be a valid action string');
    if (typeof account_number !== 'string') throw new TypeError('.account_number must be a string');
    if (typeof account_name !== 'string') throw new TypeError('.account_name must be a string');

    return new BankAccount({
      id: String(id),
      bankCode: bank_code,
      branchCode: branch_code,
      accountType: accountType_ as AccountType,
      accountNumber: account_number,
      accountName: account_name,
    });
  };
}

export default BankAccount;
